import './footer.css';

function Footer() {

  return (
    <footer className="footer">
      <div className="footer-content">
        <span>© {new Date().getFullYear()} Szczep „Lawina"</span>

        <a
          href="https://zhp.pl/informacje-i-uwagi-prawne"
          target="_blank"
          rel="noreferrer"
        >
          Informacje i uwagi prawne
        </a>

        <a
          href="https://zhp.pl/rodo"
          target="_blank"
          rel="noreferrer"
        >
          Polityka prywatności
        </a>

        <span>
          Kontakt z administratorem strony:{" "}
          <a
            href="mailto:jakub.kunysz@zhp.pl"
            target="_blank"
            rel="noreferrer"
          >
            jakub.kunysz@zhp.pl
          </a>
        </span>
      </div>
    </footer>
    
  );
}

export default Footer;